import React from "react";

const Steps = ({
  position = "top",
  currentStep,
  setCurrentStep,
  stepsList = [],
}) => {
  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }
  const labelPosition = (_position) => {
    switch (_position) {
      case "top":
        return "top-[-24px]";
        break;
      case "bottom":
        return "bottom-[-24px]";
        break;
      case "right":
        return "right-[-24px]";
        break;
      case "left":
        return "left-[-24px]";
        break;
      default:
        return "top-[-24px]";
        break;
    }
  };
  return (
    <nav aria-label="Progress">
      <ol role="list" className="flex items-center justify-center">
        {stepsList.map((step, stepIdx) => {
           return (
          <li
            key={step.name}
            className={classNames(
              stepIdx !== stepsList.length - 1 ? "pr-[170px]" : "",
              "relative"
            )}
          >
            {currentStep > stepIdx + 1 ? (
              <>
                <p
                  className={`w-34 ml-2 text-body-md font-semibold text-teal-600 text-center absolute left-0 transform -translate-x-1/2 ${labelPosition(
                    position
                  )}`}
                >
                  {step.name}
                </p>
                <div className="absolute inset-0 flex items-center">
                  <div className="h-0.5 w-full bg-REELTeal" />
                </div>
                <a className="relative flex items-center justify-center w-5 h-5 bg-white border rounded-full border-REELTeal">
                  <div className="w-3 h-3 rounded-full bg-REELTeal" />
                </a>
              </>
            ) : currentStep === stepIdx + 1 ? (
              <>
                <p
                  className={`w-34 ml-2 text-body-md font-semibold text-teal-600 text-center absolute left-0 transform -translate-x-1/2 ${labelPosition(
                    position
                  )}`}
                >
                  {step.name}
                </p>
                <div className="absolute inset-0 flex items-center">
                  <div className="h-0.5 w-full bg-teal-50" />
                </div>
                <a className="relative flex items-center justify-center w-5 h-5 bg-white border rounded-full border-REELTeal">
                  <div className="w-3 h-3 rounded-full bg-REELTeal" />
                </a>
              </>
            ) : (
              <>
                <p
                  className={`w-34 ml-2 text-body-md font-semibold text-teal-600 text-center absolute left-0 transform -translate-x-1/2 ${labelPosition(
                    position
                  )}`}
                >
                  {step.name}
                </p>
                <div className="absolute inset-0 flex items-center">
                  <div className="h-0.5 w-full bg-teal-50" />
                </div>
                <a className="relative flex items-center justify-center w-5 h-5 bg-white border rounded-full border-teal-50">
                  <div className="w-3 h-3 rounded-full bg-teal-50" />
                </a>
              </>
            )}
          </li>
         )})}
      </ol>
    </nav>
  );
};

export default Steps;
